import React from "react"

import axios from "axios"
import withBreadcrumbs from "react-router-breadcrumbs-hoc"
import { Route, Switch, matchPath, useLocation } from "react-router-dom"

import Breadcrumbs from "~tailwindui/Breadcrumbs"

import NotificationContainer from "components/NotificationContainer"

import TutorNav from "./TutorNav"
import TutorRoutes, { findRoute } from "./TutorRoutes"

const routesConfig = Object.values(TutorRoutes)
const TutorBreadcrumbs = withBreadcrumbs(routesConfig, {
  disableDefaults: true,
})(Breadcrumbs)

const AppBody = () => {
  const location = useLocation()

  const hideNav = matchPath(
    location.pathname,
    findRoute("sessionCloudroom").path
  )

  const logout = () => {
    axios.delete("/users/sign_out").then(() => (window.location.href = "/"))
  }

  return (
    <>
      {!hideNav && <TutorNav logout={logout} />}
      <div className={hideNav ? "" : "my-0 mx-3 sm:mx-auto sm:w-3/4 sm:pb-10"}>
        {!hideNav && <TutorBreadcrumbs routesConfig={routesConfig} />}
        <Switch>
          {routesConfig.map(route => (
            <Route key={route.path} {...route} />
          ))}
        </Switch>
      </div>
      <NotificationContainer />
    </>
  )
}

export default AppBody
